import React from 'react';
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment.js";
import { Icon, ICON_NAMES } from "../../../elements/Icon";
export var getLocationNameMarkup = function getLocationNameMarkup(locationName) {
  return React.createElement(Segment, {
    className: "is-location-name",
    title: locationName
  }, locationName, React.createElement(Icon, {
    color: "primary",
    name: ICON_NAMES.MAP_PIN,
    size: "small"
  }));
};